<div class="modal-backdrop" role="dialog" aria-modal="true" (click)="closeModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeModal()" type="button" aria-label="Cerrar modal">
      ×
    </button>
    <h2 *ngIf="title">{{ title }}</h2>
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
